/* Used by Storefront */

import React from "react";
import ct from "class-types.macro";
import { BranchCategoryDetail, FeaturedCategory } from "~/common/Store/models/Category";
import GridLayout from "../GridLayout";
import Sidebar from "../Sidebar";
import BottomDescription from "../BottomDescription";
import RelatedCategoryCarousel from "../RelatedCategoryCarousel";
import NonGridSplitNoChildrenGridLayout from "../GridLayoutWithNonGridSplitNoGrandchildrenView";
import EnhancedGrid from "../EnhancedGrid";
import TopProductsCarousel from "~/common/TopProductsCarousel/TopProductsCarousel";
import Breadcrumbs from "~/common/Breadcrumbs";
import { usePageTracking } from "~/analytics/usePageTracking";
const DefaultSeoCategory = (detail: BranchCategoryDetail) => {
  usePageTracking("CategoryPageEvent");
  const gridModuleSize = detail.featuredChildren.length >= 4 ? "grid-module-large" : "grid-module-small";
  const gridSplitClass = (isGridSplit: boolean) => isGridSplit === true ? " grid-split" : "";
  const displayTopProductsInMainContainer = detail.featuredChildren.length > 0 && detail.featuredChildren.filter(x => x.featuredGrandchildren.length > 0).length < 7;
  const topProducts = detail.categoryTopProducts?.map(x => x.product);
  const hideHiddenText = !displayTopProductsInMainContainer && detail.seoCategoryProperties.showTopProducts && detail.categoryTopProducts && detail.categoryTopProducts.length > 0;
  const toFeaturedChildSection = (featuredChild: FeaturedCategory) => {
    const NotEnhancedGrid = () => {
      return <div className={`grid-module grid-children-${featuredChild.featuredGrandchildren.length < 11 ? featuredChild.featuredGrandchildren.length : "max"}${gridSplitClass(featuredChild.isGridSplit)}`} key={`${featuredChild.name}${featuredChild.categoryId}`} data-sentry-component="NotEnhancedGrid" data-sentry-source-file="index.tsx">
          {!featuredChild.featuredGrandchildren.length && !featuredChild.isGridSplit && gridModuleSize === "grid-module-large" ? <NonGridSplitNoChildrenGridLayout {...{
          featuredChild,
          categoryName: detail.name,
          showActionButton: detail.seoCategoryProperties.showActionButtons,
          actionWord: detail.seoCategoryProperties.actionWord
        }} key={featuredChild.categoryId} /> : <GridLayout {...{
          featuredChild,
          categoryName: detail.name,
          actionWord: detail.seoCategoryProperties.actionWord,
          showActionButton: detail.seoCategoryProperties.showActionButtons
        }} key={featuredChild.categoryId} />}
        </div>;
    };
    return featuredChild.isEnhancedGrid ? <EnhancedGrid {...{
      ...featuredChild.enhancedGrid,
      useAlternateLayout: featuredChild.enhancedGrid.showBackground
    }} template={detail.template} data-sentry-element="EnhancedGrid" data-sentry-component="toFeaturedChildSection" data-sentry-source-file="index.tsx" /> : NotEnhancedGrid();
  };
  return <>
      <Breadcrumbs breadcrumbs={detail.layoutConfiguration.breadCrumb.items} data-sentry-element="Breadcrumbs" data-sentry-source-file="index.tsx" />
      <div className="container">
        <h1 className="page-header">{detail.name}</h1>
        <div id="page" className="clears">
          <div id="main" className="grid-layout" role="main">
            <div className={`grid-container ${gridModuleSize}`}>
              {detail.featuredChildren.map(toFeaturedChildSection)}
              <div className="grid-module-blank">
                {displayTopProductsInMainContainer && detail.seoCategoryProperties.showTopProducts && !!topProducts?.length && <div className={ct("mb-0", "xs:mb-3")} title="Top Products">
                      <TopProductsCarousel topProducts={topProducts} itemWidth={ct("w-5/12", "xsl:w-40")} productListingView="topProductsCarousel" pageType="Category" />
                    </div>}
                <RelatedCategoryCarousel relatedCategories={detail.relatedCategories} categoryName={detail.name} parentCategoryName={detail.parent.name} data-sentry-element="RelatedCategoryCarousel" data-sentry-source-file="index.tsx" />
                <div>
                  <BottomDescription bottomDescription={detail.bottomDescription} data-sentry-element="BottomDescription" data-sentry-source-file="index.tsx" />
                </div>
              </div>
            </div>
            <div className="grid-module-side aside">
              <Sidebar hideHiddenText={hideHiddenText} showTopProducts={detail.seoCategoryProperties.showTopProducts} headline={detail.seoCategoryProperties.seoHeadline} overflowText={detail.seoCategoryProperties.overflowText} visibleMarkup={detail.seoCategoryProperties.visibleMarkup} hiddenText={detail.seoCategoryProperties.seoHiddenText} visibleText={detail.seoCategoryProperties.seoVisibleText} linkedResources={detail.linkedResources} categoryTopProducts={detail.categoryTopProducts} displayTopProductsInMainContainer={displayTopProductsInMainContainer} data-sentry-element="Sidebar" data-sentry-source-file="index.tsx" />
            </div>
          </div>
        </div>
      </div>
    </>;
};
export default DefaultSeoCategory;